export const POST_ACTION_TYPES = {
  FETCH_REQUEST: "FETCH_POSTS_REQUEST",
  FETCH_SUCCESS: "FETCH_POSTS_SUCCESS",
  FETCH_FAILURE: "FETCH_POSTS_FAILURE",
  CREATE: "CREATE_POST",
  DELETE: "DELETE_POST",
  EDIT: "EDIT_POST",
}